import { createPaginator } from "@smithy/core";
import { GetLabelDetectionCommand, } from "../commands/GetLabelDetectionCommand";
import { RekognitionClient } from "../RekognitionClient";
export const paginateGetLabelDetection = createPaginator(RekognitionClient, GetLabelDetectionCommand, "NextToken", "NextToken", "MaxResults");
